import { Portal } from "@chakra-ui/react";
import React, { useCallback } from "react";

import { SeasonMapSoundEffect } from "links/lib/types";
import { useAudio } from "sharedComponents/contexts/audio";

import { FullscreenAnimationTakeover } from "../FullscreenAnimationTakeover";
import zone2UpgradeData from "./resource/zone-2-upgrade.json";
import zone3UpgradeData from "./resource/zone-3-upgrade.json";

export interface ISeason1MapZoneUnlock {
  show: boolean;
  zoneCount: number;
  handleComplete: () => void;
}

export const Season1MapZoneUnlock: React.FC<ISeason1MapZoneUnlock> = ({
  show,
  handleComplete,
  zoneCount,
}) => {
  const { play } = useAudio();

  const handlePlay = useCallback(() => {
    play(SeasonMapSoundEffect.PassUpgrade);
  }, [play]);

  return (
    <Portal>
      <FullscreenAnimationTakeover
        handleEnd={handleComplete}
        handlePlay={handlePlay}
        show={show}
        bgColor="season-map.zone-unlock-bg"
        animationData={zoneCount === 2 ? zone2UpgradeData : zone3UpgradeData}
      />
    </Portal>
  );
};
